import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { SimpleCloseIcon } from "../../../../../assets/Logos/Icons";
import PrescriptionDropDown from "../../../../PrescriptionDropdown/PrescriptionDropDown";
import styles from "./index.module.scss";
import * as yup from "yup";
import { AutoComplete, Select } from "antd";
import { AssetStore } from "../../../../../assets/AssetsStore";

function AddMedicineModal({ showModal, hidemodal, title, onSubmit }) {
  let validationMessages = [
    "Name is required !!!",
    "Composition is required !!!",
    "Category is required !!!",
  ];
  let compositions = ["Option 1", "Option 2", "Option 3", "Option 4"];

  let [compositionOptions, setCompositionOptions] = useState([]);

  useEffect(() => {
    setCompositionOptions([...convertToDropdownData(compositions)]);
  }, [])
  
  
  const [form, setForm] = useState({
    name: false,
    composition: false,
    category: false,
    isNew:true
  });

  const [errors, setErrors] = useState({
    name: "",
    composition: "",
    category: "",
  });

  let schema = yup.object().shape({
   // category: yup.string().required(validationMessages[2]),
    //composition: yup.string().required(validationMessages[1]),
    name: yup.string().required(validationMessages[0]),
  });

  const handleChange = ({ key, value }) => {
    setErrors({ ...errors, [key]: false });
    setForm({ ...form, [key]: value });
  };

  const handleSubmit = () => {
    if (form && !form.name) {
      setErrors((prev) => {
        return { ...prev, name: validationMessages[0] };
      });
    }
    // if (form && !form.composition) {
    //   setErrors((prev) => {
    //     return { ...prev, composition: validationMessages[1] };
    //   });
    // }

    // if (form && !form.category) {
    //   setErrors((prev) => {
    //     return { ...prev, category: validationMessages[2] };
    //   });
    // }
    if (form && form.name){
   // if (form && form.name && form.composition && form.category) {
      hidemodal();
      onSubmit && onSubmit({...form,  isNew:true});
      setForm({
        name: false,
        composition: false,
        category: false,
        isNew:true
      });
    }
  };

  let isEnabled = () => {
    return form && form.name;
  };

  let onCompositionSearch = (e) => {


    let filteredValues = compositions.filter((item) =>
      item.toLowerCase().includes(e.toLowerCase())
    );

    filteredValues.map((each) => {
      each = { label: each, value: each };
    });

    if (e && !filteredValues.includes(e)) {
      setCompositionOptions([
        ...convertToDropdownData(filteredValues),
        { label: e, value: e },
      ]);
    } else {
      setCompositionOptions([...convertToDropdownData(filteredValues)]);
    }
  };

  let onCompositionChange = (e) => {
   
    handleChange({ key: "composition", value: e });
 
  };

  let convertToDropdownData = (data) => {
    let result = [];
    data.map((each) => {
      result.push({ label: each, value: each });
    });
    return result;
  };

  useEffect(() => {
    setForm({
      name: false,
      composition: false,
      category: false,
    });
  }, [showModal]);


  let SelectIcon = ()=>{

    return <img src={AssetStore.mui_select} alt="" />

  }

  return (
    <Modal
      closeButton
      show={showModal}
      onHide={hidemodal}
      className={styles.add_medicine_modal_align}
      backdrop="static"
    >
      <Modal.Body>
        <div className={styles.modalContent}>
          <div className={styles.closeBar} onClick={hidemodal}>
            <SimpleCloseIcon />
          </div>
          <div className={styles.title}>{title}</div>

          <div className={styles.form_item}>
            <div className={styles.form_item_caption}>Name</div>
            <input
              value={form.name || ""}
              onChange={(e) => {
                handleChange({ key: "name", value: e.target.value });
              }}
              type="text"
              placeholder="Enter name here"
            />
            {errors.name && <div className={styles.error}>{errors.name}</div>}
          </div>

          <div className={styles.form_item} style={{display:"none"}}>
            <div className={styles.form_item_caption}>Composition</div>
            {/* <PrescriptionDropDown
                            value={form?.composition||undefined}
                            onChange={(e) => { handleChange({ key: "composition", value: e }) }}
                            defaultPlaceH={"Select composition"}
                            DataItem={["Option 1", "Option 2"]} />
                        {
                            errors.composition && <div className={styles.error}>{errors.composition}</div>
                        }*/}

            <div className={styles.autocomplete_wrap}>
            <input
                            
                         //   onChange={onCompositionChange}
                            className={styles.form_item_input} type="text" placeholder='Type here' />

              {/* <Select
               suffixIcon={<SelectIcon/>}
                showSearch
                className={styles.reason_box_container}
                getPopupContainer={(trigger) => trigger.parentNode}
                options={compositionOptions}
                onChange={onCompositionChange}
                onSearch={onCompositionSearch}
                placeholder="Input here"
              /> */}
            </div>
          </div>

          <div className={styles.form_item} style={{display:"none"}}>
            <div className={styles.form_item_caption}>Category</div>
            {/* <PrescriptionDropDown
              value={form?.category || undefined}
              onChange={(e) => {
                handleChange({ key: "category", value: e });
              }}
              defaultPlaceH={"Select category"}
              DataItem={["Option 1", "Option 2"]}
            /> */}
            <input
                            
                            onChange={(e) => {
                            //  handleChange({ key: "category", value: e });
                            }}
                            className={styles.form_item_input} type="text" placeholder='Type here' />

            {errors.category && (
              <div className={styles.error}>{errors.category}</div>
            )}
          </div>
        </div>
      </Modal.Body>
      <Button
        disabled={!isEnabled()}
        className={styles.patient_consent_accept_button}
        onClick={handleSubmit}
      >
        Save
      </Button>
    </Modal>
  );
}

export default AddMedicineModal;
